"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _react = _interopRequireDefault(require("react"));
var _radioGroup = require("../../elements-inputs/radio-group");
var _stars = require("../inputs/stars");
var _listingImage = require("../image/listing-image");
var _avatar = require("../image/avatar");
var _form = require("../forms/form");
var _apiReviews = _interopRequireDefault(require("../../../../api/api-reviews"));
var _reactIntl = require("react-intl");
var _helpers = require("../helpers/helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/*
Dependent Props:
- review
- user
- updateAction
- callback
*/
var ReviewForm = /*#__PURE__*/function (_React$Component) {
  _inherits(ReviewForm, _React$Component);
  function ReviewForm(props) {
    var _this;
    _classCallCheck(this, ReviewForm);
    _this = _callSuper(this, ReviewForm, [props]);
    _this.state = {
      msgError: null,
      is_host: false,
      is_guest: false,
      review: null,
      reviewFor: null,
      starValCaptured: null,
      bookAgainCaptured: null,
      reviewTextCaptured: null
    };
    _this.getReviewee = _this.getReviewee.bind(_assertThisInitialized(_this));
    _this.captureStarRating = _this.captureStarRating.bind(_assertThisInitialized(_this));
    _this.captureBookAgain = _this.captureBookAgain.bind(_assertThisInitialized(_this));
    _this.captureReviewText = _this.captureReviewText.bind(_assertThisInitialized(_this));
    _this.submitReview = _this.submitReview.bind(_assertThisInitialized(_this));
    _this.submitReviewCb = _this.submitReviewCb.bind(_assertThisInitialized(_this));
    _this.bookingAgainToggle = _this.bookingAgainToggle.bind(_assertThisInitialized(_this));
    _this.renderReviewForm = _this.renderReviewForm.bind(_assertThisInitialized(_this));
    _this.getAccessToken = _this.getAccessToken.bind(_assertThisInitialized(_this));
    _this.validateInput = _this.validateInput.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ReviewForm, [{
    key: "getAccessToken",
    value: function getAccessToken() {
      var accessToken;
      if (this.props.params && this.props.params.accessToken) {
        accessToken = this.props.params.accessToken;
      } else if (document && document.cookie) {
        accessToken = PSSessions.Cookies.get('PSAccess');
      } else {
        accessToken = null;
      }
      return accessToken;
    }
  }, {
    key: "getReviewee",
    value: function getReviewee() {
      var _booking$start2, _booking$start2$displ;
      var _this$props$review = this.props.review,
        review = _this$props$review === void 0 ? '' : _this$props$review;
      var _review$review_type = review.review_type,
        review_type = _review$review_type === void 0 ? '' : _review$review_type,
        _review$guest = review.guest,
        guest = _review$guest === void 0 ? '' : _review$guest,
        _review$listing = review.listing,
        listing = _review$listing === void 0 ? '' : _review$listing,
        _review$booking = review.booking,
        booking = _review$booking === void 0 ? '' : _review$booking,
        _review$use_type = review.use_type,
        use_type = _review$use_type === void 0 ? '' : _review$use_type;
      var image = {
        ratio: 1.689,
        widths: [200],
        defaultWidth: 400,
        defaultHeight: 236,
        alt: 'Peerspace',
        imgId: listing ? listing.images[0].external_id : '',
        style: 'img-responsive listing-image'
      };
      if ('guest' === review_type) {
        var _booking$start, _booking$start$displa;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "guest-review flex column middle"
        }, /*#__PURE__*/_react.default.createElement(_avatar.Avatar, {
          id: guest.avatar_id
        }), /*#__PURE__*/_react.default.createElement("h5", {
          className: "text-center ellipsis"
        }, guest.name.first || '', " ", guest.name.last || ''), /*#__PURE__*/_react.default.createElement("h5", {
          className: "text-center ellipsis full-width"
        }, listing.title), /*#__PURE__*/_react.default.createElement("div", {
          className: "text-gray-dark text-center"
        }, use_type), /*#__PURE__*/_react.default.createElement("div", {
          className: "text-gray-dark text-center"
        }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
          value: booking === null || booking === void 0 ? void 0 : (_booking$start = booking.start) === null || _booking$start === void 0 ? void 0 : (_booking$start$displa = _booking$start.display) === null || _booking$start$displa === void 0 ? void 0 : _booking$start$displa.date,
          year: "numeric",
          month: "short",
          day: "numeric",
          weekday: "short"
        })));
      }
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_listingImage.ListingImage, image), /*#__PURE__*/_react.default.createElement("h5", {
        className: "text-left ellipsis full-width"
      }, listing.title), /*#__PURE__*/_react.default.createElement("p", {
        className: "text-gray-dark text-left"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
        value: booking === null || booking === void 0 ? void 0 : (_booking$start2 = booking.start) === null || _booking$start2 === void 0 ? void 0 : (_booking$start2$displ = _booking$start2.display) === null || _booking$start2$displ === void 0 ? void 0 : _booking$start2$displ.date,
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short"
      })));
    }
  }, {
    key: "captureStarRating",
    value: function captureStarRating(starVal) {
      this.setState({
        starValCaptured: parseInt(starVal, 10)
      });
    }
  }, {
    key: "captureBookAgain",
    value: function captureBookAgain(selectedElement) {
      this.setState({
        bookAgainCaptured: 'accepted' === selectedElement.value ? 'true' : 'false'
      });
    }
  }, {
    key: "captureReviewText",
    value: function captureReviewText(event, cb) {
      this.setState({
        reviewTextCaptured: event['review-message']
      });
      return cb();
    }
  }, {
    key: "validateInput",
    value: function validateInput(errorData, validState) {
      return validState(errorData);
    }
  }, {
    key: "submitReview",
    value: function submitReview(e, cb) {
      var accessToken = this.getAccessToken();
      var data = {
        stars: this.state.starValCaptured,
        review_text: this.state.reviewTextCaptured,
        would_you_book_again: 'true' === this.state.bookAgainCaptured
      };
      var reviewID = this.props.review._id;
      if (accessToken) {
        return _apiReviews.default.update(reviewID, accessToken, data, cb);
      }
    }
  }, {
    key: "submitReviewCb",
    value: function submitReviewCb(response) {
      var reviewID = this.props.review._id;
      if (response.error || 400 < response.statusCode) {
        // Something went wrong when creating the message
        return this.setState({
          msgError: this.props.intl.formatMessage({
            id: 'shared_components.review_form.something_wrong',
            defaultMessage: 'Something went wrong. Please try again.'
          })
        });
      }
      return this.props.cbAction(reviewID);
    }
  }, {
    key: "bookingAgainToggle",
    value: function bookingAgainToggle() {
      var _this$props$review2 = this.props.review,
        review = _this$props$review2 === void 0 ? {} : _this$props$review2;
      var review_type = review.review_type;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 margin-xl-top"
      }, /*#__PURE__*/_react.default.createElement(_radioGroup.RadioGroup, {
        isRequired: true,
        ref: "radio",
        groupName: "book-again",
        changeCB: this.captureBookAgain,
        customErrorMessage: this.props.intl.formatMessage({
          id: 'shared_components.review_form.select_option',
          defaultMessage: 'Please select an option.'
        }),
        inputData: [{
          ID: 'yes',
          value: 'accepted',
          displayText: 'guest' === review_type ? this.props.intl.formatMessage({
            id: 'shared_components.review_form.host_again',
            defaultMessage: 'Yes, I would host them again'
          }) : this.props.intl.formatMessage({
            id: 'shared_components.review_form.book_again',
            defaultMessage: 'Yes, I would book again'
          })
        }, {
          ID: 'no',
          value: 'declined',
          displayText: 'guest' === review_type ? this.props.intl.formatMessage({
            id: 'shared_components.review_form.not_host_again',
            defaultMessage: 'No, I would not host them again'
          }) : this.props.intl.formatMessage({
            id: 'shared_components.review_form.not_book_again',
            defaultMessage: 'No, I would not book again'
          })
        }]
      }));
    }
  }, {
    key: "renderReviewForm",
    value: function renderReviewForm(isMobile, revieweeName) {
      var _this2 = this;
      var reviewInputMetaData = [{
        inputFieldName: 'review_response',
        elementID: 'review-message',
        ref: 'reviewMsg',
        optional: false,
        actionFn: this.captureReviewText,
        actionCb: this.validateInput,
        placeholder: this.props.intl.formatMessage({
          id: 'shared_components.review_form.leave_review_placeholder',
          defaultMessage: 'Leave a review'
        }),
        hideRequired: true
      }, {
        custom: function custom() {
          return /*#__PURE__*/_react.default.createElement(_stars.ReviewStars, {
            onChangeFn: _this2.captureStarRating,
            ref: "review-stars",
            fullWidth: true
          });
        }
      }, {
        custom: this.bookingAgainToggle
      }];
      var beforeCTA = isMobile ? /*#__PURE__*/_react.default.createElement("div", {
        id: "review-helper-text",
        className: "border-bottom padding-lg-top padding-lg-bottom"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "padding-lg-left padding-lg-right text-gray-dark text-small"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.review_form.update_bank_account_description",
        defaultMessage: "Your review will be kept private until {revieweeName} completes their review.",
        values: {
          revieweeName: revieweeName
        }
      }))) : null;
      return /*#__PURE__*/_react.default.createElement(_form.FormBuilder, {
        ref: "reviewForm",
        formStyle: "standard",
        formname: "review form",
        formInputs: reviewInputMetaData,
        submitAction: this.submitReview,
        submitCallback: this.submitReviewCb,
        isButtonDisabled: false,
        buttonText: this.props.intl.formatMessage({
          id: 'shared_components.review_form.review_form_button',
          defaultMessage: 'Submit Review'
        }),
        buttonClass: "btn btn-block btn-primary",
        errorText: this.state.msgError,
        beforeCTA: beforeCTA,
        ignoreTextAreaBlurValidation: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props,
        _this3 = this;
      var isMobile = _helpers.Helpers.isMobile();
      var revieweeName;
      var revieweeInfo = this.getReviewee();
      var _this$props$review3 = this.props.review,
        review = _this$props$review3 === void 0 ? {} : _this$props$review3;
      var _review$review_type2 = review.review_type,
        review_type = _review$review_type2 === void 0 ? '' : _review$review_type2,
        _review$guest2 = review.guest,
        guest = _review$guest2 === void 0 ? '' : _review$guest2,
        _review$host = review.host,
        host = _review$host === void 0 ? '' : _review$host,
        _review$_id = review._id,
        _id = _review$_id === void 0 ? '' : _review$_id;
      if ('guest' === review_type) {
        var _guest$name;
        revieweeName = (guest === null || guest === void 0 ? void 0 : (_guest$name = guest.name) === null || _guest$name === void 0 ? void 0 : _guest$name.first) || '';
      } else {
        var _host$name;
        revieweeName = (host === null || host === void 0 ? void 0 : (_host$name = host.name) === null || _host$name === void 0 ? void 0 : _host$name.first) || '';
      }
      var currentReview = this.props.currentReview;
      var totalReviews = ((_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.totalReviews) || 1;
      var displaySkipBtn;
      if ('guest' !== review_type || !this.props.snoozable) {
        displaySkipBtn = false;
      } else {
        displaySkipBtn = review.hasOwnProperty('allowed_to_skip') ? review.allowed_to_skip : true;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "complete-review",
        className: "complete-review flex"
      }, !isMobile && /*#__PURE__*/_react.default.createElement("div", {
        id: "review-form-left",
        className: "review-form-left text-center flex column space-between border-right"
      }, revieweeInfo, /*#__PURE__*/_react.default.createElement("div", {
        id: "review-helper-text",
        className: "margin-auto-top"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "padding-lg-left padding-lg-right text-gray-dark text-small"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.review_form.update_bank_account_description",
        defaultMessage: "Your review will be kept private until {revieweeName} completes their review.",
        values: {
          revieweeName: revieweeName
        }
      })))), /*#__PURE__*/_react.default.createElement("div", {
        id: "review-form-right",
        className: "review-form-right"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "venue_info"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "text-primary ".concat(isMobile ? 'text-center' : '')
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.review_form.review_pagination",
        defaultMessage: "{currentReview} of {totalReviews} reviews",
        values: {
          currentReview: currentReview,
          totalReviews: totalReviews
        }
      })), /*#__PURE__*/_react.default.createElement("h3", {
        className: "no-top-margin ".concat(!isMobile || 'guest' !== review_type ? 'text-left' : 'text-center')
      }, 'guest' === review_type ? this.props.intl.formatMessage({
        id: 'shared_components.review_form.review_guest_name',
        defaultMessage: 'Before continuing, leave {guest} a review'
      }, {
        guest: revieweeName
      }) : this.props.intl.formatMessage({
        id: 'shared_components.review_form.review_space',
        defaultMessage: 'Review this space'
      })), isMobile && revieweeInfo, isMobile && /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("p", {
        className: isMobile ? 'padding-xl-top border-top' : ''
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.review_form.feedback_will_help",
        defaultMessage: "Your feedback will help other {reviewType} know what to expect. Please describe your experience booking with {revieweeName}.",
        values: {
          reviewType: 'guest' === review_type ? 'hosts' : 'guests',
          revieweeName: revieweeName
        }
      })), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, 'guest' === review_type ? this.props.intl.formatMessage({
        id: 'shared_components.review_form.easy_work_with',
        defaultMessage: 'How easy were they to work with?'
      }) : this.props.intl.formatMessage({
        id: 'shared_components.review_form.responsive_was_host',
        defaultMessage: 'How responsive was the host?'
      })), /*#__PURE__*/_react.default.createElement("li", null, 'guest' === review_type ? this.props.intl.formatMessage({
        id: 'shared_components.review_form.booking_go_planned',
        defaultMessage: 'Did the booking go as planned?'
      }) : this.props.intl.formatMessage({
        id: 'shared_components.review_form.space_appear',
        defaultMessage: 'Did the space appear as advertised?'
      })), /*#__PURE__*/_react.default.createElement("li", {
        className: isMobile ? 'padding-lg-bottom' : ''
      }, 'guest' === review_type ? this.props.intl.formatMessage({
        id: 'shared_components.review_form.follow_host_rules',
        defaultMessage: 'Did they follow your host rules?'
      }) : this.props.intl.formatMessage({
        id: 'shared_components.review_form.activity_did_you_do',
        defaultMessage: 'What activity did you do in the the space?'
      })))), this.renderReviewForm(isMobile, revieweeName), displaySkipBtn && /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-block btn-no-outline",
        onClick: function onClick() {
          return _this3.props.handleSnoozeBtn(_id);
        }
      }, this.props.intl.formatMessage({
        id: 'shared_components.review_form.review_form_skip_button',
        defaultMessage: 'Snooze, I\'ll do this later'
      }))));
    }
  }]);
  return ReviewForm;
}(_react.default.Component);
exports.ReviewForm = (0, _reactIntl.injectIntl)(ReviewForm, {
  withRef: true
});